// extracted by mini-css-extract-plugin
module.exports = {"contact":"contactsList_contact__34-Wj"};